<md-dialog  aria-label="{{'DEFAULT_EXPORTAR_FIE' | translate}}">
  <form>

    <md-dialog-content>
      <div class="md-dialog-content ">
        <div class="mdl-grid tcqi-table">
          <div class="mdl-cell mdl-cell--12-col tcqi--table-header">
  		        {{'USUARIS_SESSIO' | translate}}
          </div>
          <div class="mdl-cell mdl-cell--12-col">
              {{ctrl.usuarisensessio}}
          </div>
        </div>
      </div>
    </md-dialog-content>
    <md-dialog-actions layout="row">
      <md-button class="md-primary md-button md-default-theme md-ink-ripple" ng-click="hide()">
       {{'DEFAULT_SORTIR' | translate}}
      </md-button>
    </md-dialog-actions>
  </form>
</md-dialog>
